export default [
    {
      path: '/',
      name: 'login',
      meta: {
        layout: 'login'
      },
      component: () => import('@/views/Login.vue') 
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      meta: {
        layout: 'login'
      },
      component: () => import('@/views/ForgotPassword.vue') 
    }
  ]
  